import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export abstract class WebviewService {
  public abstract closeWebView(): void;

  public abstract openContact(): void;
}
